import Link from 'next/link';

import cx from 'classnames';
import ArrowPrev from 'themes/canvas/assets/arrow-left.svg';
import ArrowNext from 'themes/canvas/assets/arrow-right.svg';

import { Heading } from 'components/Heading';

import { TReview } from 'types/review';

import { CanvasReview } from './CanvasReview';

import s from './CanvasReviews.module.css';

interface ReviewsProps {
  currentReviewIndex: number;
  onShowNextReview: () => void;
  onShowPrevReview: () => void;
  reviews: TReview[];
  aboutLink: string;
  noImage: boolean;
}

const CanvasReviews = ({
  currentReviewIndex,
  onShowNextReview,
  onShowPrevReview,
  reviews,
  aboutLink,
  noImage,
}: ReviewsProps) => {
  if (reviews.length === 0) {
    return null;
  }

  return (
    <section
      className={cx(s.root, {
        [s.noImage]: noImage,
      })}
    >
      <Heading as="h2" variant="large" className={s.hidden}>
        Reviews
      </Heading>

      <CanvasReview
        key={reviews[currentReviewIndex].id}
        review={reviews[currentReviewIndex]}
      />

      {reviews.length > 1 && (
        <nav className={s.pagination} aria-label="pagination">
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowPrevReview}
            aria-label="Previous review"
          >
            <ArrowPrev />
          </button>
          <span className={s.paginProgress}>
            {currentReviewIndex + 1} / {reviews.length}
          </span>
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowNextReview}
            aria-label="Next review"
          >
            <ArrowNext />
          </button>
        </nav>
      )}
      <div className={s.cta}>
        <Link href={aboutLink} title="all reviews">
          all reviews
        </Link>
      </div>
    </section>
  );
};

export { CanvasReviews };
